__webpack_public_path__ = window.resourceBaseUrl;



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 1133
// module chunks = 5